import React, { useState, useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { signin } from "../../../states/actions/fetchSignin";
import { useDispatch, useSelector } from "react-redux";
import SubmitButton from "../../common/SubmitButton";
import ShowPasswordIcon from "../../common/ShowPasswordIcon";
import { ErrorMessage } from "@hookform/error-message";
import { GoogleLogin } from "react-google-login";
import { gapi } from "gapi-script";
import Captcha from "../../common/captcha";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../../utils/siteSettings";

const Form = ({ content }) => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const isFormProcessing = useSelector(
    (state) => state.fetchSignin.isFormProcessing
  );
  const [isGoogleProcessing, setisGoogleProcessing] = useState(false);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const firstSubmit = (data, e) => {
    e.preventDefault();
    if (!captchaToken) {
      toast.error("Please verify the CAPTCHA", TOAST_SETTINGS);
      return;
    }
    data = {
      ...data,
      type: "web",
      captcha_token: captchaToken,
      host: window.location.hostname,
      // host: "localhost",
    };
    dispatch(signin(data, location));
  };
  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        scope: "email",
        plugin_name: "PLUGIN",
      });
    }
    gapi.load("client:auth2", start);
  }, []);
  const onSuccess = (response) => {
    let formData = { ...response, type: "google" };
    dispatch(signin(formData, location));
  };
  const onFailure = (response) => {
    console.log("FAILED", response);
  };
  return (
    <>
      {/* DISABLE-VERIFICATION: OTP screen removed. Always show login form.
          TO REVERT: wrap form in `authentication ? <AuthenticationLogin /> : (...)`,
          restore AuthenticationLogin import, and restore the authentication selector. */}
      <form method="POST" onSubmit={handleSubmit(firstSubmit)}>
          <div className="blk_form">
            <h6>Email</h6>
            <div className="form_blk">
              <input
                type="text"
                className="input"
                placeholder="Enter your email"
                {...register("email", {
                  required: "Email is required.",
                  pattern: {
                    value:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: "Please enter a valid email",
                  },
                })}
              />
              <ErrorMessage
                errors={errors}
                name="email"
                render={({ message }) => (
                  <p className="validation_error"> {message}</p>
                )}
              />
            </div>
          </div>
          <div className="blk_form">
            <h6>Password</h6>
            <div className="form_blk pass_blk">
              <input
                type={showPassword ? "text" : "password"}
                className="input"
                placeholder="Enter password"
                {...register("password", {
                  required: "Password is required.",
                })}
              />
              <ErrorMessage
                errors={errors}
                name="password"
                render={({ message }) => (
                  <p className="validation_error"> {message}</p>
                )}
              />
              <ShowPasswordIcon
                showPassword={showPassword}
                handleShowPassword={() => setShowPassword(!showPassword)}
              />
            </div>
          </div>

          <div className="forgot">
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>
          <div className="line_br"></div>
          <div className="blk_form">
            <Captcha onVerify={(token) => setCaptchaToken(token)} />
          </div>
          <div className="line_br"></div>
          <div className="btn_blk">
            <SubmitButton
              classes="site_btn"
              button_text={content.left_sec_button_text}
              isFormProcessing={isFormProcessing}
            />

            <div className="google_wrap">
              <GoogleLogin
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                buttonText={
                  isGoogleProcessing === true ? (
                    <i className="spinner"></i>
                  ) : (
                    "Sign in with Google"
                  )
                }
                className="gmBtn"
                onSuccess={onSuccess}
                onFailure={onFailure}
                disabled={isGoogleProcessing === true ? "disabled" : ""}
                cookiePolicy={"single_host_origin"}
              />
            </div>
          </div>
          <div className="dont_acc">
            <p>
              {content.signup_link_left_heading}{" "}
              <Link to="/signup">{content.signup_link_heading}</Link>
            </p>
          </div>
        </form>
    </>
  );
};

export default Form;
